import { render, staticRenderFns } from "./subproductsForm.vue?vue&type=template&id=67ee8159&"
import script from "./subproductsForm.vue?vue&type=script&lang=js&"
export * from "./subproductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports